// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mantine/core';
import { useEffect } from 'react';
import type { FC, ReactNode } from 'react';
import { useForm } from 'react-hook-form';
import type { DeepPartial, DefaultValues } from 'react-hook-form';

import { FormPanel } from '../../../components/global/FormPanel/FormPanel.tsx';
import { useI18n } from '../../../hooks/useI18n.ts';
import { About } from '../About/About.tsx';
import { CoverImage } from '../CoverImage/CoverImage.tsx';
import { Links } from '../Links/Links.tsx';
import { WhereAndWhenSingleDate } from '../WhereAndWhenSingleDate/WhereAndWhenSingleDate.tsx';
import { schema } from './schema.ts';
import type { EventFormComplete } from './schema.ts';

export const EventForm: FC<{
  defaultValues: DefaultValues<EventFormComplete>;
  onCurrentFormValueChange: (data: DeepPartial<EventFormComplete>) => void;
  submitButton: ReactNode;
  onSubmit: (data: EventFormComplete) => void;
}> = ({ defaultValues, onCurrentFormValueChange, submitButton, onSubmit }) => {
  const { t } = useI18n();

  const useFormValue = useForm<EventFormComplete>({
    resolver: zodResolver(schema),
    defaultValues,
    mode: 'onTouched',
  });

  useEffect(() => {
    const { unsubscribe } = useFormValue.watch((value) => {
      onCurrentFormValueChange(value);
    });
    return () => unsubscribe();
  }, [onCurrentFormValueChange, useFormValue, useFormValue.watch]);

  return (
    // @ts-expect-error noValidate not recognized by mantine form
    <Stack noValidate component="form" gap="xxs" onSubmit={(event) => void useFormValue.handleSubmit(onSubmit)(event)}>
      <FormPanel name="about-event" title={t('event-form_section_title--about-event') ?? 'About event'}>
        <About useFormValue={useFormValue /* @ts-expect-error noValidate not recognized by mantine form */} />
      </FormPanel>
      <FormPanel name="where-and-when" title={t('event-form_section_title--when-and-where') ?? 'Where and when?'}>
        <WhereAndWhenSingleDate useFormValue={useFormValue} />
      </FormPanel>
      <FormPanel name="cover-image" title={t('event-form_section_title--artwork') ?? 'Artwork'}>
        <CoverImage useFormValue={useFormValue} />
      </FormPanel>
      <FormPanel name="links" title={t('event-form_section_title--links') ?? 'Links'}>
        <Links useFormValue={useFormValue} />
      </FormPanel>
      {submitButton}
    </Stack>
  );
};
